var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.curRedEnvelopeData)?_c('red-envelope-not-wechat',{attrs:{"watch-origin":_vm.watchOrigin,"room-id":_vm.roomId,"red-envelope-data":_vm.curRedEnvelopeData,"redirect-url":_vm.redirectUrl},on:{"close":_vm.handleClose}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }